var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWednesdayWarrior(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1040 1040",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M619.42 623.308H295.94c-7.76 0-14.81 4.48-18.11 11.5l-141.12 300.78c-6.22 13.26 3.46 28.5 18.11 28.5h605.72c14.65 0 24.33-15.23 18.11-28.5l-141.12-300.78a19.994 19.994 0 00-18.11-11.5z",
    fill: "#B62A35",
    stroke: "#B62A35",
    strokeWidth: 20,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M653.57 701.968v149.86l138.9-146.48v-149.87l-138.9 146.49z",
    fill: "#036D79"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M814.84 555.478c-9.27-18.76-34.33-22.65-48.73-7.47l-112.54 118.69v76.26c47.54 15.13 101.67 3.08 138.3-35.56 39.8-41.98 47.19-102.92 22.97-151.93v.01z",
    fill: "#036D79"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M814.84 555.478c24.21 49 16.83 109.95-22.97 151.93",
    stroke: "#036D79",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M114.21 814.457c-12.74 16.6-4.97 40.74 15.02 46.95 52.2 16.22 111.23-.63 146.44-46.53 43.94-57.27 34.6-138.65-20.17-184.59l-141.29 184.16v.01z",
    fill: "#2C848E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M129.23 861.407c52.2 16.22 111.23-.63 146.44-46.53",
    stroke: "#036D79",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M659.971 1030.69h-100.12c-17.83 0-32.31-14.48-32.31-32.312v-21.02c0-6.23 5.06-11.29 11.29-11.29h121.14c17.83 0 32.31 14.48 32.31 32.31 0 17.832-14.48 32.312-32.31 32.312z",
    fill: "#F79253"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M526.541 966.367l1 32.02c0 17.773 14.54 32.313 32.31 32.313h100.12c17.77 0 32.31-14.54 32.31-32.313",
    stroke: "#F05360",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M255.401 966.077h121.14c6.23 0 11.29 5.06 11.29 11.29v21.02c0 17.833-14.48 32.313-32.31 32.313h-100.12c-17.83 0-32.31-14.48-32.31-32.313 0-17.83 14.48-32.31 32.31-32.31z",
    fill: "#F79253"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M386.821 966.367l1 32.02c0 17.773-14.54 32.313-32.31 32.313h-100.12c-17.77 0-32.31-14.54-32.31-32.313",
    stroke: "#F05360",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M686.45 536.707v321.65c0 62.9-48.41 114.51-110 119.58-3.29.28-6.63.42-10 .42H348.92c-3.37 0-6.71-.14-10-.42-61.6-5.07-110-56.68-110-119.58v-321.65c0-126.34 102.42-228.76 228.76-228.76 63.17 0 120.36 25.6 161.76 67 41.4 41.4 67.01 98.59 67.01 161.76z",
    fill: "#2C848E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M576.45 862.767v-151.77c0-65.53-52.53-119.69-118.06-120.07-65.81-.39-119.47 53.03-119.47 118.76v153.08c0 41.75 33.85 75.6 75.6 75.6h86.33c41.75 0 75.6-33.85 75.6-75.6z",
    fill: "#fff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M537.901 468.107h-.01c-32.839 0-59.46 26.622-59.46 59.46v49.27c0 32.839 26.621 59.46 59.46 59.46h.01c32.839 0 59.46-26.621 59.46-59.46v-49.27c0-32.838-26.621-59.46-59.46-59.46z",
    fill: "#fff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M547.891 586.297c-16.25 0-29.46-13.22-29.46-29.46v-49.26c0-16.25 13.22-29.46 29.46-29.46 16.24 0 29.46 13.22 29.46 29.46v49.26c0 16.25-13.22 29.46-29.46 29.46z",
    fill: "#044548"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M537.851 535.667l-19.44 11.22c-2.67 1.54-6-.38-6-3.46v-22.45c0-3.08 3.33-5 6-3.46l19.44 11.22c2.67 1.54 2.67 5.39 0 6.93zM377.481 468.107h-.01c-32.839 0-59.46 26.622-59.46 59.46v49.27c0 32.839 26.621 59.46 59.46 59.46h.01c32.839 0 59.46-26.621 59.46-59.46v-49.27c0-32.838-26.621-59.46-59.46-59.46z",
    fill: "#fff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M387.471 478.107c16.25 0 29.46 13.22 29.46 29.46v49.26c0 16.25-13.22 29.46-29.46 29.46-16.24 0-29.46-13.22-29.46-29.46v-49.26c0-16.25 13.22-29.46 29.46-29.46z",
    fill: "#044548"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M397.521 528.737l19.44-11.22c2.67-1.54 6 .38 6 3.46v22.45c0 3.08-3.33 5-6 3.46l-19.44-11.22c-2.67-1.54-2.67-5.39 0-6.93z",
    fill: "#fff"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M441.6 522.298c0-5.01.02-10.1.04-15.19.28-50.75-56.51-81.74-98.43-53.15-6.71 4.58-11.18 9.57-12 14.92l110.38 53.41.01.01z",
    fill: "#2C848E"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M329.181 466.638l111.21 54.34",
    stroke: "#036D79",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M475.181 522.298c0-5.01-.02-10.1-.04-15.19-.28-50.75 56.51-81.74 98.43-53.15 6.71 4.58 11.18 9.57 12 14.92l-110.38 53.41-.01.01z",
    fill: "#2C848E"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M587.601 466.638l-111.21 54.34",
    stroke: "#036D79",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M687.86 627.968c-3.64 0-7.069 1.63-9.459 4.38-38.93 44.8-123.121 75.83-220.721 75.83-97.6 0-181.789-31.02-220.719-75.83-2.39-2.75-5.81-4.38-9.46-4.38h-.25c-7.44 0-13.25 6.51-12.32 13.9 11.24 89.52 115.619 159.67 242.749 159.67s231.51-70.14 242.75-159.67c.93-7.38-4.88-13.9-12.32-13.9h-.25z",
    fill: "#EF3A48",
    stroke: "#EF3A48",
    strokeWidth: 20,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M262.4 703.688c44.45 42.819 115.37 70.549 195.28 70.549s150.83-27.719 195.28-70.549",
    stroke: "#B62A35",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M736.45 536.707v67.51c0 16.57-13.43 30-30 30h-99.98c13.03-15.54 20.89-35.56 20.89-57.38v-48.12c0-49.18-40.23-90.58-89.41-90.61-35.15-.02-65.63 20.32-80.27 49.87-14.63-29.55-45.13-49.9-80.29-49.87-49.17.04-89.38 41.43-89.38 90.6v48.13c0 21.82 7.85 41.84 20.88 57.38h-99.97c-16.57 0-30-13.43-30-30v-67.51c0-74.46 28.99-144.46 81.64-197.11 52.65-52.65 122.66-81.65 197.12-81.65 74.46 0 144.46 29 197.11 81.65 52.66 52.65 81.66 122.66 81.66 197.11z",
    fill: "#FED425"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M316.64 430.918s-2.84-53.22-73.76-69.78z",
    fill: "#FED425"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M316.64 430.918s-2.84-53.22-73.76-69.78",
    stroke: "#FFEEBD",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M598.73 430.918s2.84-53.22 73.76-69.78z",
    fill: "#FED425"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M598.73 430.918s2.84-53.22 73.76-69.78",
    stroke: "#FFEEBD",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M496.69 325.518h-78.01v117.11h78.01v-117.11z",
    fill: "#F79253",
    stroke: "#FED425",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M721.78 447.097c-13.55-40.04-36.22-76.74-66.99-107.5-52.65-52.65-122.65-81.65-197.11-81.65-74.46 0-144.47 29-197.12 81.65-30.76 30.76-53.43 67.46-66.98 107.5",
    stroke: "#F79253",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M606.47 639.217a5.005 5.005 0 01-3.83-8.22c12.72-15.17 19.72-34.4 19.72-54.17v-48.12c0-22.54-8.82-43.93-24.83-60.23-16.06-16.35-37.22-25.36-59.58-25.38-32.38 0-61.4 18.04-75.79 47.09a5 5 0 01-8.96 0c-14.38-29.04-43.4-47.09-75.73-47.09-22.43.02-43.59 9.03-59.64 25.38-16.01 16.3-24.82 37.69-24.82 60.22v48.13c0 19.77 7 39.01 19.71 54.17a5.006 5.006 0 01-3.83 8.22h-99.97c-19.3 0-35-15.7-35-35 0-2.76 2.24-5 5-5h76.13c-1.35-7.39-2.04-14.89-2.04-22.38v-48.13c0-33.08 12.88-64.42 36.28-88.24 23.63-24.06 54.91-37.33 88.07-37.36h.11c23.62 0 46.63 6.68 66.54 19.31 4.77 3.02 9.35 6.39 13.67 10.03 4.32-3.64 8.9-7.01 13.67-10.03 19.91-12.63 42.95-19.31 66.62-19.31 33.18.02 64.47 13.29 88.1 37.35 23.4 23.83 36.29 55.17 36.29 88.26v48.12c0 7.49-.69 14.99-2.04 22.38h76.13c2.76 0 5 2.24 5 5 0 19.3-15.7 35-35 35h-99.98z",
    fill: "#FFEEBD"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M537.97 408.107c31.82.02 61.85 12.75 84.53 35.85 22.48 22.89 34.86 52.99 34.86 84.75v48.12c0 9.27-1.09 18.46-3.2 27.38h82.29c0 16.57-13.43 30-30 30h-99.98c13.03-15.54 20.89-35.56 20.89-57.38v-48.12c0-49.18-40.23-90.58-89.41-90.61h-.06c-35.12 0-65.58 20.34-80.21 49.87-14.62-29.53-45.09-49.87-80.21-49.87h-.08c-49.17.04-89.38 41.43-89.38 90.6v48.13c0 21.82 7.85 41.84 20.88 57.38h-99.97c-16.57 0-30-13.43-30-30h82.29c-2.11-8.92-3.2-18.11-3.2-27.38v-48.13c0-31.76 12.38-61.85 34.85-84.74 22.68-23.1 52.69-35.83 84.51-35.86h.1c22.67 0 44.75 6.41 63.86 18.53a119.88 119.88 0 0116.35 12.45 119.88 119.88 0 0116.35-12.45c19.11-12.12 41.19-18.53 63.94-18.53m.01-9.99c-24.62 0-48.59 6.95-69.3 20.08-3.79 2.4-7.46 5.01-10.99 7.8-3.53-2.79-7.21-5.4-10.99-7.8-20.71-13.14-44.65-20.08-69.22-20.08h-.1c-34.53.03-67.07 13.83-91.65 38.85-24.32 24.77-37.71 57.35-37.71 91.75v48.13c0 5.81.4 11.62 1.18 17.38h-70.27c-5.52 0-10 4.48-10 10 0 22.06 17.94 40 40 40h99.97a9.99 9.99 0 009.06-5.77 9.992 9.992 0 00-1.4-10.65 79.421 79.421 0 01-18.54-50.95v-48.13c0-21.21 8.31-41.35 23.39-56.71 15.11-15.38 34.99-23.87 56-23.88h.07c15.07 0 29.75 4.26 42.44 12.3a79.872 79.872 0 0128.81 32 9.995 9.995 0 008.96 5.56c3.8 0 7.27-2.15 8.96-5.56a79.903 79.903 0 0128.82-32 79.08 79.08 0 0142.43-12.31h.06c21.01.01 40.9 8.5 56.01 23.88 15.09 15.36 23.4 35.51 23.4 56.73v48.12c0 18.59-6.59 36.69-18.55 50.95a9.995 9.995 0 007.66 16.42h99.98c21.97 0 39.86-17.8 40-39.74v-.26c0-5.52-4.47-10-10-10h-70.28c.79-5.76 1.18-11.58 1.18-17.38v-48.12c0-34.4-13.4-66.99-37.72-91.76-24.58-25.03-57.13-38.82-91.66-38.85zM389.79 352.527c-10.36 0-18.8-8.74-18.8-19.47v-96.51c0-10.74 8.43-19.47 18.8-19.47h135.78c10.36 0 18.8 8.74 18.8 19.47v96.51c0 10.74-8.43 19.47-18.8 19.47H389.79z",
    fill: "#FED425"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M525.57 225.077c5.96 0 10.8 5.14 10.8 11.47v96.51c0 6.34-4.83 11.47-10.8 11.47H389.79c-5.96 0-10.8-5.14-10.8-11.47v-96.51c0-6.34 4.83-11.47 10.8-11.47h135.78zm0-16H389.79c-14.78 0-26.8 12.32-26.8 27.47v96.51c0 15.15 12.02 27.47 26.8 27.47h135.78c14.78 0 26.8-12.32 26.8-27.47v-96.51c0-15.15-12.02-27.47-26.8-27.47z",
    fill: "#F79253"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M495.03 170.758h-74.69c-6.57 0-12.38-3.181-16.03-8.07v154.229h106.74V162.688c-3.65 4.889-9.46 8.07-16.03 8.07h.01z",
    fill: "#EF3A48",
    stroke: "#EF3A48",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M404.31 239.798v77.11h106.74v-77.11",
    stroke: "#B62A35",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M495.03 30.027h-74.69c-11.045 0-20 8.955-20 20v100.73c0 11.046 8.955 20 20 20h74.69c11.046 0 20-8.954 20-20V50.027c0-11.045-8.954-20-20-20z",
    fill: "#F05360",
    stroke: "#EF3A48",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M515.03 100.388v50.36c0 5.52-2.24 10.52-5.86 14.14a19.938 19.938 0 01-14.14 5.86h-74.69c-5.52 0-10.52-2.24-14.14-5.86a19.938 19.938 0 01-5.86-14.14v-50.36",
    stroke: "#B62A35",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M802.201 679.198c-7.72 0-14-6.28-14-14v-35.24c0-2.21 1.79-4 4-4h74.69c2.21 0 4 1.79 4 4v35.24c0 7.72-6.28 14-14 14h-54.69z",
    fill: "#F4817F"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M866.891 629.968v35.24c0 5.52-4.48 10-10 10h-54.69c-5.52 0-10-4.48-10-10v-35.24h74.69zm0-8h-74.69c-4.42 0-8 3.58-8 8v35.24c0 9.93 8.07 18 18 18h54.69c9.93 0 18-8.07 18-18v-35.24c0-4.42-3.58-8-8-8z",
    fill: "#F05360"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M857.061 457.367h-55.02a4 4 0 00-4 4v168.6a4 4 0 004 4h55.02a4 4 0 004-4v-168.6a4 4 0 00-4-4z",
    fill: "#044548"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M857.051 461.367v168.6h-55.02v-168.6h55.02zm0-8h-55.02c-4.42 0-8 3.58-8 8v168.6c0 4.42 3.58 8 8 8h55.02c4.42 0 8-3.58 8-8v-168.6c0-4.42-3.58-8-8-8z",
    fill: "#044548"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M890.121 113.138h-120.69v312.26h120.69v-312.26z",
    fill: "#FED425"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M861.651 148.068l-31.87-34.93-31.87 34.93v277.34h63.74v-277.34z",
    fill: "#F79253"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M889.541 113.147h.59l-47.66-95.31c-5.23-10.45-20.14-10.45-25.37 0l-47.65 95.3 28.48 34.931 31.58-34.601 31.58 34.601 28.47-34.921h-.02z",
    fill: "#FFEEBD"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M855.06 43.028l-12.589-25.19c-5.23-10.45-20.141-10.45-25.371 0l-12.6 25.19h50.56z",
    fill: "#F05360"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M790.96 640.677c-7.33 0-13.29-5.96-13.29-13.29 0-7.33 5.96-13.29 13.29-13.29h77.18c7.33 0 13.29 5.96 13.29 13.29 0 7.33-5.96 13.29-13.29 13.29h-77.18z",
    fill: "#7C8D97"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M868.131 618.087a9.29 9.29 0 010 18.58h-77.18a9.29 9.29 0 010-18.58h77.18zm0-8h-77.18c-9.53 0-17.29 7.76-17.29 17.29s7.76 17.29 17.29 17.29h77.18c9.53 0 17.29-7.76 17.29-17.29s-7.76-17.29-17.29-17.29z",
    fill: "#044548"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M797.45 508.547l29.97-17.3c26.67-15.4 60 3.85 60 34.64v34.61c0 30.79-33.33 50.04-60 34.64l-29.97-17.3c-26.67-15.4-26.67-53.89 0-69.28v-.01z",
    fill: "#2C848E"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M827.42 595.127l-14.99-8.65-14.99-8.65c-13.33-7.7-20-21.17-20-34.64 0-13.47 6.67-26.94 20-34.64l14.99-8.65 14.99-8.65",
    stroke: "#036D79",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M914.631 425.407h-169.7c-9.743 0-17.64 7.898-17.64 17.64v11.4c0 9.743 7.897 17.64 17.64 17.64h169.7c9.742 0 17.64-7.897 17.64-17.64v-11.4c0-9.742-7.898-17.64-17.64-17.64z",
    fill: "#7C8D97",
    stroke: "#044548",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M418.44 613.898a97.254 97.254 0 0139.24-8.26c13.37 0 26.74 2.75 39.24 8.26",
    stroke: "#FED425",
    strokeWidth: 50,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M440.811 239.798v77.11M472.511 239.798v77.11",
    stroke: "#B62A35",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWednesdayWarrior);
export default ForwardRef;